// src/sass/components/header/Header.jsx
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import HeaderTopbar from "../HeaderTopbar/HeaderTopbar";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo from "../../images/logo.png";

const Header = () => {
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => window.scrollTo(10, 0);

  const phoneDisplay = "703-662-3685";
  const phoneDial = phoneDisplay.replace(/[^0-9]/g, "");

  const proposalsEmail = "support@jmccontractinggroup.com";
  const subject = encodeURIComponent("Proposal Request");
  const body = encodeURIComponent(
    "Hi JMC Contracting Group,\n\nI’d like to request a proposal/estimate.\n\nProject Location:\nType of Work:\nDesired Start Date:\nBest Contact Name/Phone:\n\nAdditional Details:\n"
  );
  const mailtoHref = `mailto:${proposalsEmail}?subject=${subject}&body=${body}`;

  return (
    <header id="header" className="no-topbar">
      <div className="wpo-site-header compact-header fixed-navbar">
        <HeaderTopbar />

        <nav className="navigation navbar navbar-expand-lg navbar-light">
          <div className="container">
            <div className="row align-items-center">
              {/* Mobile hamburger */}
              <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                <div className="mobail-menu">
                  <MobileMenu />
                </div>
              </div>

              {/* Logo */}
              <div className="col-lg-3 col-md-6 col-6">
                <div className="navbar-header">
                  <Link onClick={ClickHandler} className="navbar-brand" to="/">
                    <img src={Logo} alt="JMC Contracting Group LLC" />
                  </Link>
                </div>
              </div>

              {/* Nav */}
              <div className="col-lg-6 col-md-1 col-1">
                <div
                  id="navbar"
                  className="collapse navbar-collapse navigation-holder"
                >
                  <ul className="nav navbar-nav mb-2 mb-lg-0">
                    <li>
                      <NavLink onClick={ClickHandler} to="/" end>
                        HOME
                      </NavLink>
                    </li>

                    <li>
                      <NavLink onClick={ClickHandler} to="/service">
                        SERVICES
                      </NavLink>
                    </li>

                  </ul>
                </div>
              </div>

              {/* CTA */}
              <div className="col-lg-3 col-md-2 col-2">
                <div className="header-right">
                  {/* Hidden template search toggle - leave to avoid breaking layout */}
                  <div className="header-search-form-wrapper">
                    <div className="cart-search-contact">
                      <button
                        onClick={() => setMenuState(!menuActive)}
                        className="search-toggle-btn"
                        type="button"
                      >
                        <i
                          className={`ti-search ${
                            menuActive ? "ti-close" : "ti-search"
                          }`}
                        />
                      </button>
                    </div>
                  </div>

                  <div className="col-lg-12 estimate-bar">
                    {/* Mailto button instead of /proposal route */}
                    <a className="theme-btn" href={mailtoHref}>
                      Email Proposals
                    </a>

                    <a className="header-phone" href={`tel:${phoneDial}`}>
                      {phoneDisplay}
                    </a>
                  </div>
                </div>
              </div>
              {/* end CTA */}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;